import React from 'react';
import image1 from '../../images/indoor.png';
import image2 from '../../images/people.png';
import image3 from '../../images/taco.png';
import image4 from '../../images/bar.png';
import image5 from '../../images/umbrella.png';
import image6 from '../../images/slushie.png';

import styles from './index.module.css';

export default function Homesliders() {
  return (
    <div className={styles.homeSliders}>
      <div className={styles.leftSlider}>
        <figure>
          <div className={styles.box}>
            <img src={image1} alt="" />
            <img src={image2} alt="" />
            <img src={image3} alt="" />
          </div>
          <div className={styles.box}>
            <img src={image4} alt="" />
            <img src={image5} alt="" />
            <img src={image6} alt="" />
          </div>
          <div className={styles.box}>
            <img src={image1} alt="" />
            <img src={image2} alt="" />
            <img src={image3} alt="" />
          </div>
        </figure>
      </div>
      <div className={styles.rightSlider}>
        <figure>
          <div className={styles.box}>
            <img src={image1} alt="" />
            <img src={image2} alt="" />
            <img src={image3} alt="" />
          </div>
          <div className={styles.box}>
            <img src={image4} alt="" />
            <img src={image5} alt="" />
            <img src={image6} alt="" />
          </div>
          <div className={styles.box}>
            <img src={image1} alt="" />
            <img src={image2} alt="" />
            <img src={image3} alt="" />
          </div>
        </figure>
      </div>
    </div>
  );
}
